import { TreemapLayoutType,  TreemapOrientation } from 'igniteui-react-charts';

/* 
  An array of all the various treemap layout options
 */

export const layoutOptions = [
  "Squared", 
  "Slice Vertically", 
  "Slice Horizontally", 
  "Strip Vertically",
  "Strip Horizontally", 
];

/* 
  Based on selectedLayout variable, treeMap layout and orientation is set
  < input = treeMap, selectedLayout, setLayoutCallback >
 */
export function onLayoutChange(treeMap, selectedLayout, setLayoutCallback) {
  switch (selectedLayout) {

    case "Squared":
      treeMap.layoutType = TreemapLayoutType.Squarified;
      break;

    case "Slice Vertically":
      treeMap.layoutType = TreemapLayoutType.SliceAndDice;
      treeMap.layoutOrientation = TreemapOrientation.Vertical;
      break;

    case "Slice Horizontally":
      treeMap.layoutType = TreemapLayoutType.SliceAndDice;
      treeMap.layoutOrientation = TreemapOrientation.Horizontal;
      break;

    case "Strip Vertically":
      treeMap.layoutType = TreemapLayoutType.Stripped;
      treeMap.layoutOrientation = TreemapOrientation.Vertical;
      break;

    case "Strip Horizontally":
      treeMap.layoutType = TreemapLayoutType.Stripped;
      treeMap.layoutOrientation = TreemapOrientation.Horizontal;
      break;

    // Default state
    default:
      treeMap.layoutType = TreemapLayoutType.Squarified;
      break;
  }

  // Update the components layout state
  setLayoutCallback({
    selectedLayout,
  });
}
